module.exports = __webpack_public_path__ + "static/media/Tick-DeepFrozenApps-397275646.b685cef5.mp3";